$(document).ajaxComplete(function (event, request, settings) {
    // On re-bind les components a chaque call Ajax
    App.Kernel.bindComponents($("body"));
});